
import { Link } from 'react-router-dom';
import offre_clarte from '../images/Offre_Clarte.jpg';
import offre_connaissance from '../images/Offre_connaissance.jpg';
import offre_STAR from '../images/Offre_STAR.jpg';


import {Helmet} from "react-helmet";



function Offre() {

      
      
      

      return (
            <div className="Offre">
              
            
              <Helmet>
       
       <title>Offre détaillée entretiens lettres de motivation et coaching</title>
       <meta name="description" content="Une offre sur-mesure pour répondre avec des mots précis, personnels et convaincants aux questions décisives du jury dans tous vos entretiens de motivation"></meta>
       <link rel="canonical" href="https://www.winentretien.com/offre" />

      </Helmet>
      

      <div class="column" id="main">

      <div id="titre_second" class='column_items_center'>
                              
                              <h1>Offre de services</h1>
                              
                              <h2under2></h2under2>

                              
                              
                        </div>

<div id="soustitre_offre">
      
<h2 class="mobile_off">

Préparation aux entretiens et coaching
professionnel
</h2>



<div class='underline2 mobile_off'></div></div>

<hcontent>

L’offre de services se décline sur deux domaines de spécialisation :
la <strong>préparation aux entretiens</strong> de motivation et le <strong>coaching</strong> auprès
des étudiants.<br/><br/>

- <blue>Entretiens de motivation pour les étudiants :</blue> concours d’entrée à
toutes les grandes écoles<br/><br/>

- <blue>Entretiens de motivation pour les professionnels :</blue> tout type
d’entretien d’embauche<br/><br/>

- <blue>Coaching étudiant :</blue> organisation de travail, choix d’orientation,
coaching Parcoursup

                       

</hcontent>
      
      <Link to='/contact' onClick={() => window.scrollTo(0,10)}>
      <button id='bouton' >Me Contacter</button>
      </Link>
      
</div>



<div id="titre_second" class='column_items_center mobile_off'>
                              
                              
                              <h1>L'offre</h1>
                              
                              <h2under2></h2under2>
                              <div class="note column_items_center">
                              
      <content> Étudiants, professionnels, une offre sur-mesure pour toutes les étapes importantes de votre parcours

                              
                               </content></div>
                              
                        </div> 

                        <br/><br/>

                        <div class="Home2_offres window">


            

<div class="block mobile_off">
  <h2title>Coaching étudiants :</h2title>
<br/>
<content1>
<blue>Confiance et efficacité</blue><br/>
S'appuyer sur l'expérience d'un coach pendant les années de collège, lycée, et dans toutes les étapes de parcoursup.
</content1>

<Link to="/LP/coaching-étudiants" onClick={() => window.scrollTo(0,10)}>
                <button id='bouton' >Découvrir</button>
                
                
                </Link>

</div>

<div class="block mobile_off">
  <h2title>Entretiens étudiants :</h2title>
<br/>
<content1>
<blue>Intégrez l'école de votre choix </blue><br/> Préparez les oraux de tous les concours d'entrée aux grandes écoles postbac <br/><br/>


</content1>

<Link to="/LP/entretiens-étudiants" onClick={() => window.scrollTo(0,10)}>
                <button id='bouton' >Découvrir</button>
                
                
                </Link>

</div>

<div class="block mobile_off">
  <h2title>Entretiens professionnels :</h2title>
<br/>
<content1>
<blue>Apprenez à convaincre</blue><br/>
Comprenez les enjeux des entretiens d'embauche et apprenez à convaincre les recruteurs

</content1>

<Link to="/LP/entretiens-professionnels" onClick={() => window.scrollTo(0,10)}>
                <button id='bouton' >Découvrir</button>
                
                
                </Link>

</div>




            </div>

           
            <div class="methode_step column"><br/><br/><br/><br/>
         <h3>Connaissance de soi</h3>
         <h2under></h2under> </div>    
         

            <div class="flex block window methode_part2">

<div class="methode_text">

<content1>

Pour convaincre un jury ou un recruteur, il faut être capable de
 communiquer <strong>qui l’on est</strong>, et savoir partager sa motivation.<br/>

C’est pourquoi nous allons évoquer ensemble :<br/><br/>
<blue>
- votre parcours et vos compétences<br/>

- vos valeurs<br/>

- vos qualités et vos défauts<br/>

- vos centres d’intérêt<br/></blue><br/>

L’objectif est de <strong>savoir parler de soi</strong> - à l’oral ou par écrit – avec objectivité et précision</content1>


      
</div>

<div class="column mobile_off">
<img class="image_methode_2" src={offre_connaissance} alt=""/>
<br/>
</div>

  </div> 









  <div class="methode_step column">
         <h3>Clarté et précision</h3>
         <h2under></h2under> </div> 


  <div class="flex block window methode_part2">



  <img class="image_methode_2" src={offre_clarte} id="image_coaching_4" alt=""/>

<div class="column_items_center">


<div class="methode_text">


<content1>
<blue>Communiquer</blue> c’est avant tout choisir ce que l’on va dire : les mots
que vous employez, à l’écrit comme à l’oral, ont le pouvoir de
convaincre.
<br/><br/>
Nous vous aidons à choisir les mots qui vont répondre aux questions
posées dans un entretien, ou ceux qui vont le mieux communiquer
votre motivation dans une lettre.
<br/><br/>
Comme vous avez peu de temps pour convaincre, nous allons vous
challenger pour que vos récits – car vos réponses sont des récits –
soient <blue>clairs et précis.</blue>
<br/><br/>
Avec cette exigence, nous augmentons votre crédibilité – et donc
vos chances de réussir.
<br/><br/>


</content1>


      
</div>
</div>


  </div>

          

  <div class="methode_step column">
         <h3>Méthode STAR</h3>
         <h2under></h2under> </div>    
         

            <div class="flex block window methode_part2">

<div class="methode_text">

<content1>
Pour mieux convaincre, nous vous encourageons à montrer les
preuves des compétences que vous affichez.
C’est ce que propose la méthode STAR :<br/><br/>

<blue>S pour Situation</blue> – le contexte général<br/>

<blue>T pour Tâche</blue> – la mission ou l’objectif à atteindre<br/>

<blue>A pour Action</blue> – ce que vous avez mis en place pour atteindre
l’objectif<br/>

<blue>R pour Réalisation</blue> – le résultat obtenu<br/><br/>

Votre discours devient plus structuré, plus personnel.

Vous apportez de plus la preuve de votre esprit d’analyse.<br/>
</content1>


      
</div>

<div class="column mobile_off">
<img class="image_methode_2" src={offre_STAR} alt=""/>
<br/>
</div>

  </div>         


          

           

           


  <br/><br/><br/><br/>     

         

           


<div class="window">

            <div class="line_between" id="offre_content_telephone">

<div class="column_items_center">
  <h4title><blue>+ 600</blue></h4title>
  <h2under2></h2under2>
  <br/>
  <h2title>Entretiens depuis
2007</h2title>
</div>
<div class="column_items_center">
  <h4title><blue>98 %</blue></h4title>
  <h2under2></h2under2>
  <br/>
  <h2title>de taux de réussite moyen</h2title>
</div>
<div class="column_items_center">
  <h4title><blue>100 %</blue></h4title>
  <h2under2></h2under2>
  <br/>
  <h2title>de taux de satisfaction</h2title>
</div>


</div>                       
<br/><br/><br/><br/><br/>
</div>



       <div class="Home2_offres window">


            

<div class="block">
  <h2title>Coaching étudiants :</h2title>
<br/>
<content1>
<blue>Confiance et efficacité</blue><br/>
S'appuyer sur l'expèrience d'un coach pendant les années de collège, lycée, et dans toutes les étapes de parcoursup.
</content1>

<Link to="/LP?nb=39" onClick={() => window.scrollTo(0,10)}>
                <button id='bouton' >Découvrir</button>
                
                
                </Link>

</div>

<div class="block">
  <h2title>Entretiens étudiants :</h2title>
<br/>
<content1>
<blue>Intégrez l'école de votre choix </blue><br/> Préparez les oraux de tous les concours d'entrée aux grandes écoles postbac <br/><br/>


</content1>

<Link to="/LP?nb=64" onClick={() => window.scrollTo(0,10)}>
                <button id='bouton' >Découvrir</button>
                
                
                </Link>

</div>

<div class="block">
  <h2title>Entretiens professionnels :</h2title>
<br/>
<content1>
<blue>Apprenez à convaincre</blue><br/>
Comprenez les enjeux des entretiens d'embauche et apprenez à convaincre les recruteurs

</content1>

<Link to="/LP?nb=50" onClick={() => window.scrollTo(0,10)}>
                <button id='bouton' >Découvrir</button>
                
                
                </Link>

</div>




            </div>           


                        
    

            
                        
                        
                        
            


            </div>
      );
}

export default Offre;